import { render } from "./studioPage.vue?vue&type=template&id=11f65ed4&scoped=true"
import script from "./studioPage.vue?vue&type=script&lang=js"
export * from "./studioPage.vue?vue&type=script&lang=js"

import "./studioPage.vue?vue&type=style&index=0&id=11f65ed4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dadao-im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f65ed4"]])

export default __exports__